import { render, staticRenderFns } from "./VerificationBadgesPage.vue?vue&type=template&id=98aa24b2&scoped=true"
import script from "./VerificationBadgesPage.vue?vue&type=script&lang=js"
export * from "./VerificationBadgesPage.vue?vue&type=script&lang=js"
import style0 from "./VerificationBadgesPage.vue?vue&type=style&index=0&id=98aa24b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98aa24b2",
  null
  
)

export default component.exports